import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { CategoryBadge } from "@/components/feature/ArticleCard";

export default function HeroSection() {
  const lead = articles[0];
  const sideList = articles.slice(1, 5);

  return (
    <section aria-labelledby="hero-title" className="border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-shell px-4 py-8 md:px-6 md:py-10">
        <div className="mb-6 flex flex-col gap-2 border-b border-background-300 pb-4 sm:flex-row sm:items-center sm:justify-between">
          <p className="flex items-center gap-2 text-xs font-semibold tracking-[0.22em] text-primary-600">
            <i className="ri-record-circle-line animate-pulse text-base" aria-hidden="true" />
            今日头条 · 独家首发
          </p>
          <p className="text-xs text-secondary-600">
            编辑部值守中 ｜ 每日 09:00 更新 · 2026 年 9 月 10 日
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 rise-in lg:grid-cols-12">
          <article className="lg:col-span-7">
            <Link to={`/article/${lead.id}`} className="group block cursor-pointer">
              <div className="relative h-[260px] w-full overflow-hidden rounded-lg md:h-[400px]">
                <img
                  src={lead.cover}
                  alt={lead.title}
                  title={`${lead.title} - 爆料在线`}
                  className="h-full w-full object-top object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
                  <div className="mb-3 flex items-center gap-3">
                    <span className="rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                      独家猛料
                    </span>
                    <span className="text-xs text-background-200">{lead.date}</span>
                  </div>
                  <h2
                    id="hero-title"
                    className="font-heading text-xl font-black leading-snug text-background-50 md:text-3xl"
                  >
                    {lead.title}
                  </h2>
                  <p className="mt-3 hidden max-w-2xl text-sm leading-relaxed text-background-200/90 sm:block">
                    {lead.excerpt}
                  </p>
                </div>
              </div>
              <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-secondary-600">
                <span className="flex items-center gap-1">
                  <i className="ri-user-3-line" aria-hidden="true" />
                  {lead.author}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line" aria-hidden="true" />
                  {lead.views} 阅读
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-time-line" aria-hidden="true" />
                  约 {lead.readMinutes} 分钟
                </span>
                <span className="ml-auto flex items-center gap-1 font-medium text-primary-600">
                  阅读全文
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </span>
              </div>
            </Link>
          </article>

          <div className="lg:col-span-5">
            <h3 className="mb-3 flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
              <i className="ri-bookmark-3-line text-primary-600" aria-hidden="true" />
              编辑室精选
            </h3>
            <div className="flex flex-col gap-4">
              {sideList.map((item) => (
                <Link
                  key={item.id}
                  to={`/article/${item.id}`}
                  className="group flex cursor-pointer gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
                >
                  <div className="h-20 w-24 shrink-0 overflow-hidden rounded-md">
                    <img
                      src={item.cover}
                      alt={item.title}
                      title={`${item.title} - 爆料在线`}
                      className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <CategoryBadge slug={item.category} />
                    <h4 className="mt-1.5 text-sm font-medium leading-snug text-foreground-900 group-hover:text-primary-600 line-clamp-2">
                      {item.title}
                    </h4>
                    <p className="mt-1 text-xs text-secondary-600">{item.date}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}